module.exports = __webpack_public_path__ + "img/perm_device_information.5a060e08.svg";